import { computed, onBeforeUnmount, ref } from 'vue';
import { readPosition } from '../lib/persistedState';

const positionKey = 'chronis.time-converter.position.v1';

export function useTimeConverterDialog() {
  const timeConverterOpen = ref(false);
  const timeConverterPosition = ref((() => {
    const saved = readPosition(localStorage, positionKey);
    return { x: Math.max(8, saved?.x ?? Math.round(Math.max(16, (window.innerWidth - 960) / 2))), y: Math.max(8, saved?.y ?? 70) };
  })());
  const timeConverterStyle = computed(() => ({ left: `${timeConverterPosition.value.x}px`, top: `${timeConverterPosition.value.y}px` }));
  let drag: { offsetX: number; offsetY: number } | null = null;

  function openTimeConverterDialog() {
    timeConverterPosition.value = { x: Math.min(timeConverterPosition.value.x, Math.max(8, window.innerWidth - 120)), y: Math.min(timeConverterPosition.value.y, Math.max(8, window.innerHeight - 80)) };
    timeConverterOpen.value = true;
  }
  function startTimeConverterDrag(event: PointerEvent) {
    if ((event.target as HTMLElement).closest('button')) return;
    event.preventDefault();
    drag = { offsetX: event.clientX - timeConverterPosition.value.x, offsetY: event.clientY - timeConverterPosition.value.y };
    window.addEventListener('pointermove', moveTimeConverter);
    window.addEventListener('pointerup', stopTimeConverterDrag);
  }
  function moveTimeConverter(event: PointerEvent) {
    if (!drag) return;
    timeConverterPosition.value = {
      x: Math.min(Math.max(8, event.clientX - drag.offsetX), Math.max(8, window.innerWidth - 120)),
      y: Math.min(Math.max(8, event.clientY - drag.offsetY), Math.max(8, window.innerHeight - 80))
    };
  }
  function stopTimeConverterDrag() {
    if (!drag) return;
    drag = null;
    window.removeEventListener('pointermove', moveTimeConverter);
    window.removeEventListener('pointerup', stopTimeConverterDrag);
    try { localStorage.setItem(positionKey, JSON.stringify(timeConverterPosition.value)); } catch { /* Speicher ist optional. */ }
  }
  onBeforeUnmount(stopTimeConverterDrag);
  return { timeConverterOpen, timeConverterStyle, timeConverterPosition, openTimeConverterDialog, startTimeConverterDrag, stopTimeConverterDrag };
}
